import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=14a323be&scoped=true&"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeletion.vue?vue&type=style&index=0&id=14a323be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a323be",
  null
  
)

export default component.exports